import React from 'react'
import styled from 'styled-components'
import { PATH as AUTOMATIC_PLAN_PATH } from 'src/pages/automaticPlan'
import LPHeader from 'src/components/layout/Header/LPHeader'
import StepsHeader from 'src/components/layout/Header/StepHeader'
import { useNavigate, useParams } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom'
import usePlanSelection from 'src/hook/usePlanSelection'
import LocalStorage from 'src/utils/LocalStorage'

export enum FinalQuestionChoice {
  BUY_PLAN = 'buy_plan',
  NOT_BUY_PLAN = 'not_buy_plan',
  REVIEW_PLANS = 'review_plans',
}

const FinalQuestionsContainer: React.FC = () => {
  const navigate = useNavigate()
  const paramsUrl = useParams()
  const [searchParams] = useSearchParams()
  const menuId = searchParams.get('menu_id') || paramsUrl.id
  const userTreatmentId = LocalStorage.getUserTreatmentId()
  const { handlePlanSelection } = usePlanSelection(userTreatmentId)

  const handleSelect = async (choice: FinalQuestionChoice) => {
    if (
      choice === FinalQuestionChoice.BUY_PLAN ||
      choice === FinalQuestionChoice.REVIEW_PLANS
    ) {
      return navigate(
        `${AUTOMATIC_PLAN_PATH.CHOOSE_SERVICE_PLAN}?menu_id=${menuId}&choice=${choice}`,
      )
    }

    if (choice === FinalQuestionChoice.NOT_BUY_PLAN) {
      await handlePlanSelection({ waitDoctorProposal: true })
    }
  }

  return (
    <>
      <LPHeader />
      <Wrapper className="w-full justify-center">
        <StepsHeader
          step={10}
          // stepActive={4}
          stepActiveName={'最後のご質問'}
          className="top-70"
        />

        <HeaderStyle>
          <p>以下の質問にお答えください</p>
          <b>処方を受けたいプランは決まっていますか？</b>
        </HeaderStyle>

        <Options>
          <OptionButton
            onClick={() => handleSelect(FinalQuestionChoice.BUY_PLAN)}
          >
            決まっている
          </OptionButton>
          <OptionButton
            onClick={() => handleSelect(FinalQuestionChoice.NOT_BUY_PLAN)}
          >
            決まっていない
          </OptionButton>
          <OptionButton
            onClick={() => handleSelect(FinalQuestionChoice.REVIEW_PLANS)}
          >
            もう一度
            <br />
            プラン一覧を見たい
          </OptionButton>
        </Options>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div`
  margin-top: 60px;
`

const HeaderStyle = styled.div`
  padding: 0 15px;
`

const Options = styled.div`
  margin-top: 2rem;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

const OptionButton = styled.button`
  width: 100%;
  max-width: 230px;
  height: 65px;
  padding: 0.9rem 1rem;
  border-radius: 9999px;
  background-color: #f5f3e9;
  color: #1f2937;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #e6e6e0;
  }
`

export default FinalQuestionsContainer
